/**
 * The registry helper behind CLAUDE.md rule 6 ("registries, not special cases").
 * Column types, view types, automation units and dashboard widgets all use it, so a new unit is
 * one folder plus one `register()` call and nothing else in the codebase changes.
 */
export class DuplicateRegistrationError extends Error {
    registryName;
    key;
    constructor(registryName, key) {
        super(`${registryName}: duplicate registration for "${key}"`);
        this.registryName = registryName;
        this.key = key;
        this.name = 'DuplicateRegistrationError';
    }
}
export class UnknownRegistryKeyError extends Error {
    registryName;
    key;
    known;
    constructor(registryName, key, known) {
        super(`${registryName}: unknown key "${key}" (known: ${known.join(', ') || 'none'})`);
        this.registryName = registryName;
        this.key = key;
        this.known = known;
        this.name = 'UnknownRegistryKeyError';
    }
}
export function createRegistry(name, keyOf) {
    const store = new Map();
    const registry = {
        name,
        get size() {
            return store.size;
        },
        register(entry) {
            const key = keyOf(entry);
            if (typeof key !== 'string' || key.length === 0) {
                throw new Error(`${name}: registry key must be a non-empty string`);
            }
            if (store.has(key))
                throw new DuplicateRegistrationError(name, key);
            store.set(key, entry);
            return entry;
        },
        registerAll(entries) {
            for (const entry of entries)
                registry.register(entry);
        },
        get(key) {
            const entry = store.get(key);
            if (entry === undefined)
                throw new UnknownRegistryKeyError(name, key, [...store.keys()]);
            return entry;
        },
        find(key) {
            return store.get(key);
        },
        has(key) {
            return store.has(key);
        },
        keys() {
            return [...store.keys()];
        },
        list() {
            return [...store.values()];
        },
        entries() {
            return [...store.entries()];
        },
        clear() {
            store.clear();
        },
    };
    return registry;
}
//# sourceMappingURL=registry.js.map